module.exports = __webpack_public_path__ + "static/eggs-099e661b542dd6faffbcf8901f4f6c8f.jpg";